import React from "react";
import { Pressable, Text, View } from "react-native";

import AIExhibitNarrationPressable from "../audio/AIExhibitNarrationPressable";
import { useAIExhibitFixedNarration } from "../audio/useAIExhibitFixedNarration";
import { AI_EXHIBIT_COLORS as C } from "../aiExhibitTheme";

const AVAILABLE_SCREEN_IDS = new Set([
  "train_machine",
  "sentiment",
  "neural_network",
  "next_token",
  "llm_assistant",
  "ai_mistakes",
]);

export default function HowAIWorksScreen({
  navigate,
  copy,
  language = "en",
  audioEnabled = false,
}) {
  const { playNarration } = useAIExhibitFixedNarration({
    audioEnabled,
    language,
  });
  return (
    <View style={{ padding: 28 }}>
      <Text style={{ color: C.accent, fontSize: 13, fontWeight: "900", letterSpacing: 1.2 }}>
        {copy.howItWorks.eyebrow}
      </Text>
      <Text style={{ color: C.text, fontSize: 46, lineHeight: 52, fontWeight: "900", marginTop: 8 }}>
        {copy.howItWorks.title}
      </Text>
      <Text style={{ color: C.muted, fontSize: 19, lineHeight: 28, marginTop: 8, maxWidth: 920 }}>
        {copy.howItWorks.subtitle}
      </Text>

      <AIExhibitNarrationPressable
        audioEnabled={audioEnabled}
        onPress={() => playNarration("how_ai_works_overview")}
        style={{ flexDirection: "row", alignItems: "center", flexWrap: "wrap", gap: 10, marginTop: 26 }}
      >
        {copy.howItWorks.flow.map((item, index) => (
          <React.Fragment key={item}>
            <View style={{ flexGrow: 1, minWidth: 180, padding: 16, borderRadius: 15, borderWidth: 1, borderColor: C.border, backgroundColor: C.surfaceRaised }}>
              <Text style={{ color: C.text, fontSize: 17, fontWeight: "900", textAlign: "center" }}>{item}</Text>
            </View>
            {index < copy.howItWorks.flow.length - 1 ? (
              <Text style={{ color: C.accent, fontSize: 24, fontWeight: "900" }}>→</Text>
            ) : null}
          </React.Fragment>
        ))}
      </AIExhibitNarrationPressable>

      <View style={{ flexDirection: "row", flexWrap: "wrap", gap: 14, marginTop: 24 }}>
        {copy.howItWorks.cards.map((card) => {
          const available = AVAILABLE_SCREEN_IDS.has(card.id);

          return (
            <Pressable
              key={card.id}
              onPress={available ? () => navigate(card.id) : undefined}
              disabled={!available}
              style={({ pressed }) => ({
                width: "31.8%",
                minWidth: 290,
                flexGrow: 1,
                minHeight: 155,
                padding: 20,
                borderRadius: 18,
                borderWidth: 1,
                borderColor: C.border,
                backgroundColor: available && pressed ? C.accentSoft : C.surfaceRaised,
                opacity: available ? 1 : 0.48,
              })}
            >
              <Text style={{ fontSize: 30 }}>{card.icon}</Text>
              <Text style={{ color: C.text, fontSize: 20, fontWeight: "900", marginTop: 11 }}>{card.title}</Text>
              <Text style={{ color: C.muted, fontSize: 15, lineHeight: 22, marginTop: 7 }}>{card.subtitle}</Text>
            </Pressable>
          );
        })}
      </View>

      <View style={{ marginTop: 18, padding: 16, borderRadius: 15, borderLeftWidth: 5, borderWidth: 1, borderColor: C.border, borderLeftColor: C.accent, backgroundColor: C.accentSoft }}>
        <Text style={{ color: C.text, fontSize: 16, lineHeight: 25 }}>{copy.howItWorks.guardrail}</Text>
      </View>
    </View>
  );
}
